<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-card>
        <v-card-title>Modelo de geração dos números da sorte </v-card-title>
        <v-card-text>
          <v-row v-if="raffle.lucky_number_generation_type === 'SECAP'">
            <v-col cols="3" class="pb-0">
              <span class="subtitle-bold-font"
                >Número de registro
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <mf-icon class="help-icon" size="18">info</mf-icon>
                    </span>
                  </template>
                  <span>Registro do sorteio do SECAP.</span>
                </v-tooltip></span
              >

              <mf-text-input
                v-model="raffle.register_number"
                outlined
                placeholder="Sem registro"
                dense
                :disabled="isDisabled"
                :error="validations.raffle.register_number.$error"
                :error-messages="errorRegisterNumber"
                :value="raffle.register_number"
                :min="0"
                :show-arrows="false"
              />
            </v-col>
            <v-col cols="3" class="pb-0">
              <span class="subtitle-bold-font">Série inicial</span>
              <mf-number-input
                v-model="raffle.min_series"
                outlined
                placeholder="1"
                dense
                :disabled="isDisabled"
                :error="validations.raffle.min_series.$error"
                :error-messages="errorMinSeries"
                :auto-format="typeof raffle.min_series === 'number'"
                :min="0"
                :max="999"
                :show-arrows="false"
              />
            </v-col>
            <v-col cols="3" class="pb-0">
              <span class="subtitle-bold-font">Série final</span>
              <mf-number-input
                v-model="raffle.max_series"
                placeholder="200"
                outlined
                dense
                :disabled="isDisabled"
                :error="validations.raffle.max_series.$error || raffle.max_series === 0"
                :error-messages="raffle.max_series === 0 ? 'O valor precisa ser 1 ou maior.' : errorMaxSeries"
                :auto-format="typeof raffle.max_series === 'number'"
                :value="raffle.max_series"
                :min="0"
                :max="999"
                :show-arrows="false"
              />
            </v-col>
            <v-col cols="3" class="pb-0">
              <span class="subtitle-bold-font">Quantidade de séries</span>
              <mf-number-input outlined disabled dense :auto-format="typeof raffle.max_series === 'number'" :value="numberOfSeries" :show-arrows="false" />
            </v-col>
            <v-col cols="12" class="py-0">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="d-flex icon-container mt-3">
                    <mf-icon fill large color="vermelho-l20"> warning </mf-icon>
                    <p class="subtitle ma-0">
                      A quantidade de séries limita o total de números da sorte gerados, cada série contém 100.000 números. Os cupons gerados no sorteio depois
                      do limite ser atingido não vão receber números da sorte. As séries final e inicial são <b>inclusivas</b>, ou seja, se a série final for
                      99, o maior número da sorte possível será 99.999.999.
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RaffleRegistryMode',
  props: {
    validations: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    raffleValue: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    errorRegisterNumber() {
      if (!this.validations.raffle.register_number) return ''
      if (this.validations.raffle.register_number.$error) return 'Campo obrigatório.'
      return ''
    },
    errorMinSeries() {
      const minSeries = this.validations?.raffle?.min_series

      if (!minSeries?.$error) return ''
      if (!minSeries.required) return 'Campo obrigatório.'
      if (!minSeries.numeric) return 'Campo numérico.'
      if (!minSeries.lesserOrEqualThanMax) return 'Valor precisa ser menor ou igual à série máxima.'

      return ''
    },

    errorMaxSeries() {
      const maxSeries = this.validations?.raffle?.max_series

      if (!maxSeries?.$error) return ''
      if (!maxSeries.required) return 'Campo obrigatório.'
      if (!maxSeries.numeric) return 'Campo numérico.'
      if (!maxSeries.greaterOrEqualThanMin) return 'Valor precisa ser maior ou igual à série mínima.'

      return ''
    },
    localRaffleValue: {
      get() {
        return this.raffleValue
      },
      set(value) {
        this.$emit('update:raffle-value', value)
      },
    },
    numberOfSeries() {
      if (this.raffle.min_series === null || this.raffle.max_series === null) return null
      return this.raffle.max_series - this.raffle.min_series + 1
    },
  },
}
</script>

<style lang="scss" scoped>
.raffle-type-subtitle {
  font-size: 16px;
}
.icon-container {
  align-items: center;
  gap: 10px;
}
</style>
